/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolvedEmailTemplateResponse
 */
export interface ResolvedEmailTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof ResolvedEmailTemplateResponse
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedEmailTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the ResolvedEmailTemplateResponse interface.
 */
export function instanceOfResolvedEmailTemplateResponse(value: object): value is ResolvedEmailTemplateResponse {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ResolvedEmailTemplateResponseFromJSON(json: any): ResolvedEmailTemplateResponse {
    return ResolvedEmailTemplateResponseFromJSONTyped(json, false);
}

export function ResolvedEmailTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedEmailTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function ResolvedEmailTemplateResponseToJSON(json: any): ResolvedEmailTemplateResponse {
    return ResolvedEmailTemplateResponseToJSONTyped(json, false);
}

export function ResolvedEmailTemplateResponseToJSONTyped(value?: ResolvedEmailTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'content': value['content'],
    };
}

